import React from 'react';
import { ReactComponent as LoadingSpinner } from '../../../assets/loading-spinner.svg';
import classNames from 'classnames';
import styles from './Button.module.scss';

interface ButtonProps {
  onClick: () => void;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  isLoading?: boolean;
  type?: 'primary' | 'secondary' | 'tertiary' | 'link';
}

const CustomButton: React.FC<ButtonProps> = ({
  onClick,
  children,
  className = '',
  disabled = false,
  isLoading = false,
  type = 'primary',
}) => {
  return (
    <button
      // type={type}
      onClick={onClick}
      className={classNames(styles.btn, className, {
        [styles.btnPrimary]: type === 'primary',
        [styles.btnSecondary]: type === 'secondary',
        [styles.btnTertiary]: type === 'tertiary',
        [styles.btnLink]: type === 'link',
      })}
      disabled={disabled || isLoading}
    >
      {isLoading && <LoadingSpinner />}
      {children}
    </button>
  );
};

export default CustomButton;
